/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Reply_PlaceholderInputs */

const en_settings_tickets_reply_placeholder = /** @type {(inputs: Settings_Tickets_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a reply...`)
};

const zh_settings_tickets_reply_placeholder = /** @type {(inputs: Settings_Tickets_Reply_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入回复内容…`)
};

/**
* | output |
* | --- |
* | "Write a reply..." |
*
* @param {Settings_Tickets_Reply_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_reply_placeholder = /** @type {((inputs?: Settings_Tickets_Reply_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Reply_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_reply_placeholder(inputs)
	return zh_settings_tickets_reply_placeholder(inputs)
});
export { settings_tickets_reply_placeholder as "settings.tickets.reply_placeholder" }